import { useCallback as n } from "react";
import { usePLMapboxStoreV2 as u } from "./index.es6.js";
const i = () => n(
  (b, o) => u.subscribe(
    (s) => {
      var e, r;
      return (r = (e = s.maps) == null ? void 0 : e[b]) == null ? void 0 : r.basemap;
    },
    (s, e) => {
      s && s !== e && o(s);
    }
  ),
  []
);
export {
  i as useOnBasemapChange
};
//# sourceMappingURL=index.es197.js.map
